import config from './internetConfig';
import getLanguage from '../services/language';

const dicts = {
	'en-us': {
		webSearch: 'All',
		videosSearch: 'Videos',
		journalsSearch: 'Journals',
		podcastsSearch: 'Podcasts',
		guidanceSearch: 'Guidance',
		printSearch: 'Print Resources',
	},
	'es-us': {},
};

const internetLanguage = getLanguage(config, dicts);

export default internetLanguage;
